import { useEffect } from "react";
import { useBookingStore } from "./bookingStore";

export function useBookingStoreHydration() {
  const setHasHydrated = useBookingStore((s) => s.setHasHydrated);

  useEffect(() => {
    setHasHydrated(true);
  }, [setHasHydrated]);
}
